import App from "./components/App";
import React, { Component } from "react";
import ReactDOM from "react-dom";
ReactDOM.render(
    <App />,
  document.getElementById("p2p-crew")
);